import React, {useContext, useEffect, useState} from "react";
const EventContext = React.createContext();

export function useEvent() {
    return useContext(EventContext);
}

export function EventProvider({ children }) {
    const [events, setEvents] = useState([]);
    const [stackedEvents, setStackedEvents] = useState([]);

    const value = {
        events,
        setEvents,
        stackedEvents,
        setStackedEvents,
    };

    return <EventContext.Provider value={value}>{children}</EventContext.Provider>;
}

export default EventContext;
